import React,{useState} from 'react';
const Accordion = (props) => {

    return(
        <>
                <div className="accordion" id={props.id}>
                        <div className={`accordion-item box border-0 mb-3 ${props.overflow} rounded-2`}>
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target={`#${props.collapseName}`} aria-expanded="false">
                                    {props.title} &nbsp; <span className='text-secondary'>{props.subtitle}</span>
                                </button>
                            </h2>
                            <div id={props.collapseName} className={`accordion-collapse collapse ${props.className}  ${props.defaultOpen ? 'show' : ''}`} >
                            {props.children}
                            </div>
                        </div>
                    </div>

        </>

    );
}

function AccordionBody(props){
    return(
    <div className={`accordion-body ${props.className}`}>
          {props.children}
       </div>
    );
}

export {Accordion,AccordionBody};
